import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sovos-login-redirect',
  template: '<p>Redirecting to Sovos login...</p>'
})
export class SovosLoginRedirectComponent implements OnInit {
  ngOnInit(): void {
    try {
      window.location.href = `${environment.apiUrl}/sovos/auth/login`;
    } catch (e) {
      console.error('Redirect to Sovos login failed', e);
    }
  }
}
